/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import FormCreator from "../../../../components/FinalForms/FormCreator";
import { configureSkillCategoryFormData } from "./config/ConfigureSkillCategory.data";
import Buttons from "../../../../components/ui/button/Buttons";
import { useAddJobSkillCategoriesMutation, useLazyGetAllSkillCategoriesQuery } from "../../../../app/services/skillCategoriesAPI";
import { setDropDownOptionField } from "../../../../utils/FormFields/FieldsSetting/SetFieldSetting";
import { onResetForm } from "../../../../utils/FormFields/ResetForm/handleResetForm";
import ToastService from "../../../../services/toastService/ToastService";

const ConfigureSkillCategory = ({ positionAppliedId, isOpen, onClose,refreshGrid }) => {
    const ref = useRef();
    const [formData, setFormData] = useState(configureSkillCategoryFormData);
    const [shouldRerenderFormCreator, setShouldRerenderFormCreator] = useState(false);
    const [getAllSkillCategories, { isFetching: isGetAllSkillCategoriesFetching, isSuccess: isGetAllSkillCategoriesSuccess, data: isGetAllSkillCategoriesData, },] = useLazyGetAllSkillCategoriesQuery();
    const [addJobSkillCategories, { isLoading: isAddJobSkillCategoriesLoading, isSuccess: isAddJobSkillCategoriesSuccess, data: isAddJobSkillCategoriesData }] = useAddJobSkillCategoriesMutation();

    useEffect(() => {
        if (isOpen && positionAppliedId) {
            getAllSkillCategories()
        }
    }, [isOpen, getAllSkillCategories])

    useEffect(() => {
        if (!isGetAllSkillCategoriesFetching && isGetAllSkillCategoriesSuccess && isGetAllSkillCategoriesData) {
            setDropDownOptionField(isGetAllSkillCategoriesData, "skillCategoriesId", "skillCategoriesName", formData, "skillCategoriesId");
            setShouldRerenderFormCreator((prevState) => !prevState);
        }
    }, [isGetAllSkillCategoriesFetching, isGetAllSkillCategoriesSuccess, isGetAllSkillCategoriesData, formData]);

    const handleAddSkillCategoryClick = () => {
        let skillForm = ref.current.getFormData();
        if (skillForm && positionAppliedId) {
            const request = {
                positionAppliedId: positionAppliedId,
                skillCategoriesId: skillForm.skillCategoriesId?.value,
            }
            addJobSkillCategories(request);
        }
    }

    useEffect(() => {
        if (isAddJobSkillCategoriesSuccess && isAddJobSkillCategoriesData) {
            if (isAddJobSkillCategoriesData.errorMessage.includes("exists")) {
                ToastService.warning(isAddJobSkillCategoriesData.errorMessage);
                return;
              }
            onClose();
            onResetForm(configureSkillCategoryFormData, setFormData, null)
            refreshGrid();
            ToastService.success(isAddJobSkillCategoriesData.errorMessage);
        }
    }, [isAddJobSkillCategoriesSuccess && isAddJobSkillCategoriesData])

    return (<div className="mt-3">
        <form>
            <div className="row">
                <FormCreator
                    config={formData}
                    ref={ref}
                    {...formData}
                    key={shouldRerenderFormCreator}
                />
            </div>
        </form>
        <div className="row mt-3">
            <div className="col-12">
                <div className="form-btn d-flex justify-content-end">
                    <Buttons
                        buttonTypeClassName="btn dark-btn"
                        onClick={onClose}
                        buttonText="Cancel"
                    />
                    <Buttons
                        buttonTypeClassName="btn theme-btn ml-5"
                        onClick={handleAddSkillCategoryClick}
                        buttonText="Add"
                        isLoading={isAddJobSkillCategoriesLoading}

                    />
                </div>
            </div>
        </div>
    </div>)
}
export default ConfigureSkillCategory;